import {
  SearchValidator,
  EmailValidator,
  PhoneValidator,
  LicensePlateValidator,
  CustomerNameValidator,
  OrderIdValidator
} from "./validators/searchValidator";

export const IsValidSearchInput = (input, validationCriteria = 0) => {
    const validator = getValidator(validationCriteria)
    return input != "" && validator.validate(input)
};

export const getParamFromCriteria = (input) => {
  const { criteriaSelected } = input
  const validator = getValidator(criteriaSelected);
  return validator.getParam(input);
}

const getValidator = (criteriaSelected) => {
  const validator = new SearchValidator();

  switch (criteriaSelected) {
    case 0:
      validator.validator = new LicensePlateValidator();
      break;
    case 1:
      validator.validator = new PhoneValidator();
      break;
    case 2:
      validator.validator = new EmailValidator();
      break;
    case 3:
      validator.validator = new CustomerNameValidator();
      break;
    case 4: 
      validator.validator = new OrderIdValidator({orderType: 'workOrder'});
      break;
    case 5: 
      validator.validator = new OrderIdValidator({orderType: 'invoice'});
      break;
    default:
      break;
  }
  return validator;
}